/**
 * Same flag as {@link appendMockWebinarsUiDev}: enables mock webinar rows and
 * shows the Webinars sidebar entry without Zoom integration.
 */
export function isMockWebinarsUiDevEnabled(): boolean {
  return process.env.REACT_APP_MOCK_WEBINARS === 'true'
}
